import { defineMessages } from 'react-intl-next';

export const i18n: {
	attachedDateLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	lastActive: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	messageTypeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	privateChannelLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	threadTypeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	threadTypeLabel: {
		id: 'dynamic-cards-search-page.search-result.thread-type-label',
		defaultMessage: 'Thread',
		description:
			'Metadata label on a search result item in the dynamic cards search page. Generic label for a third party app where there is a linked entity.',
	},
	messageTypeLabel: {
		id: 'dynamic-cards-search-page.search-result.message-type-label',
		defaultMessage: 'Message',
		description:
			'Metadata label on a search result item in the dynamic cards search page. Generic label for a third party app where there is NOT a linked entity.',
	},
	lastActive: {
		id: 'dynamic-cards-search-page.search-result.message-last-active',
		defaultMessage: 'Last active {formattedDate}',
		description:
			'Metadata label on a search result item in the dynamic cards search page. Shows the last active date for the Message metadata label',
	},
	attachedDateLabel: {
		id: 'dynamic-cards-search-page.search-result.attachments.attached-date.label',
		defaultMessage: 'Attached {formattedDate}',
		description:
			'Metadata label on a search result item in the dynamic cards search page. Shows the date the attachment was added',
	},
	privateChannelLabel: {
		id: 'dynamic-cards-search-page.search-result.private-channel-label',
		defaultMessage: 'Private Channel',
		description:
			'Metadata label on a search result item in the dynamic cards search page. Label showing that the search item is a private slack channel',
	},
});
